<template>
  <div class="custom-checkbox" @click="toggleCheck">
    <div
      :class="{
        inner: true,
        'is-checked': isChecked,
      }"
    >
      <img
        v-if="isChecked"
        src="../../assets/images/icons/selected.png"
        alt=""
      />
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: "CustomCheckbox",
  props: {
    value: Boolean,
    label: String,
  },
  computed: {
    isChecked() {
      return this.value;
    },
  },
  methods: {
    toggleCheck() {
      this.$emit("input", !this.isChecked);
    },
  },
};
</script>

<style scoped lang="less">
.custom-checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
  .inner {
    width: 12px;
    height: 12px;
    background: #ffffff;
    border: 1px solid #979797;
    border-radius: 12px;
    margin-right: 3px;
    &.is-checked {
      border: 0;
      background: none;
      img {
        display: block;
      }
    }
  }
}
.checkbox-label {
  margin-left: 8px;
}
</style>
